<template>
    <div :class="{'element': true, 'error': errors.has(label), 'focused':focused, 'required': required && required.indexOf('required') > -1 }">
        <label :class="{'float': true, 'active': active}" :for="label">{{ placeholder ? placeholder : label }}</label>
        <input v-validate="required" :data-vv-scope="scope" v-model="value" :id="label" :name="label" type="text" :placeholder="placeholder ? placeholder : label" @keypup="checkRestrictions()" @focus="focused = true" @input="checkDateInput()" @blur="blurActions()">
        <span v-show="errors.has(scope+'.'+label)" class="error">{{ errors.first(scope+'.'+label) }}</span>
    </div>
</template>
<script type='text/babel'>
    import element from '../../element'

    export default {
        mixins: [element],
        methods: {
            blurActions(){
                this.focused = false
                if (this.restrictions === 'birthdate') {
                    this.setAge()
                    // this.checkDateBlur()
                }
            },
            checkRestrictions() {
                if (this.restrictions === 'numeric') {
                    this.value = this.value.replace(/[^0-9 ]/g, "")
                }
                if (this.restrictions === 'zipcode') {
                    let first_four_digits = this.value.substr(0, 4)
                    let two_chars = this.value.substr(4, 6)
                    if (first_four_digits.length === 4 && two_chars.length === 2 && this.value.length === 6) {
                        this.value = first_four_digits + ' ' + two_chars
                    }
                    this.value = this.value.toUpperCase();
                }

                if (this.restrictions === 'start-with-capital') {
                    this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1)
                }
            },
            checkDateValue(str, max) {
                if (str.charAt(0) !== '0' || str == '00') {
                    var num = parseInt(str);
                    if (isNaN(num) || num <= 0 || num > max) num = 1;
                    str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
                }
                return str;
            },
            checkDateInput(){
                if (this.restrictions === 'birthdate') {
                    this.type = 'text';
                    let input = this.value;
                    if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
                    var values = input.split('-').map(function (v) {
                        return v.replace(/\D/g, '')
                    });
                    if (values[0]) values[0] = this.checkDateValue(values[0], 31);
                    if (values[1]) values[1] = this.checkDateValue(values[1], 12);
                    var output = values.map(function (v, i) {
                        return v.length == 2 && i < 2 ? v + '-' : v;
                    });
                    this.value = output.join('').substr(0, 12);
                    this.setAge()
                }
            },
            checkDateBlur(){
                if (this.restrictions === 'birthdate') {
                    this.type = 'text';
                    var input = this.value;
                    var values = input.split('-').map(function (v, i) {
                        return v.replace(/\D/g, '')
                    });
                    var output = '';

                    if (values.length == 3) {
                        var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
                        var month = parseInt(values[1]) - 1;
                        var day = parseInt(values[0]);
                        var d = new Date(year, month, day);
                        if (!isNaN(d)) {
                            // document.getElementById('result').innerText = d.toString();
                            var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
                            output = dates.map(function (v) {
                                v = v.toString();
                                return v.length == 1 ? '0' + v : v;
                            }).join('-');
                        }
                        ;
                    }
                    this.value = output;
                    this.setAge();
                }
            },
            setAge() {
                if (this.restrictions === 'birthdate') {
                    var parts = this.value.split('-');
                    var date = parts[2]+'-'+parts[1]+'-'+parts[0];
                    let age = this.getAge(date)
                    this.$store.dispatch('setAge', age)
                }
            },
            getAge(date) {
                var birthday = new Date(date);
                var ageDifMs = Date.now() - birthday.getTime();
                var ageDate = new Date(ageDifMs); // miliseconds from epoch
                return Math.abs(ageDate.getUTCFullYear() - 1970);
            },
        }
    }
</script>
